<template>
  <div class="paymentErrorAudit">
    <el-form ref="form" :inline="true" class="form" :model="searchForm">
      <el-form-item label="合同编号" prop="contractNum">
        <el-input v-model.trim="searchForm.contractNum" placeholder="请选择合同编号" />
      </el-form-item>
      <el-form-item label="项目名称" prop="projectName">
        <el-input v-model.trim="searchForm.projectName" placeholder="请选择项目名称" />
      </el-form-item>
      <el-form-item label="代理商名称" prop="orderUnit">
        <el-input v-model.trim="searchForm.orderUnit" placeholder="请选择代理商名称" />
      </el-form-item>
      <el-form-item label="部门" prop="departmentName">
        <el-input v-model.trim="searchForm.departmentName" placeholder="请选择部门" />
      </el-form-item>
      <el-form-item label="区域" prop="regionName">
        <el-input v-model.trim="searchForm.regionName" placeholder="请选择区域" />
      </el-form-item>
      <el-form-item label="申请人" prop="applicationName">
        <el-input v-model.trim="searchForm.applicationName" placeholder="请选择申请人" />
      </el-form-item>
      <el-form-item label="申请时间：" prop="createBeginTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            />
          </div>
          <div class="date-separator">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            />
          </div>
        </div>
      </el-form-item>
      <el-button ref="searchBtn" type="primary" :loading="tableLoading" @click="searchClick()">
        查询
      </el-button>
      <el-button type="default" @click="resetForm">
        重置
      </el-button>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%" tooltip-effect="light">
        <el-table-column prop="contractNum" label="操作" width="80" align="left" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" @click="toPaymentErrorAudit(row)">
              办理
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="contractNum" label="合同编号" align="left" width="140" />
        <el-table-column prop="projectName" label="项目名称" align="left" />
        <el-table-column prop="orderUnit" label="代理商名称" align="left" />
        <el-table-column prop="transferFromCode" label="已分配金额/比例" align="right" header-align="left">
          <template v-slot="{row}">
            {{ row.assignAll }}/{{ row.proportion }}%
          </template>
        </el-table-column>
        <el-table-column prop="cancellationAmount" label="申请撤销金额" align="right" header-align="left" />
        <el-table-column prop="departmentName" label="部门" align="left" />
        <el-table-column prop="regionName" label="区域" align="left" />
        <el-table-column prop="applicationName" label="申请人" align="left" />
        <el-table-column prop="applicationTime" label="申请时间" align="left" />
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper"
          :total="page.total"
          hide-on-single-page
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <!-- 办理 -->
    <el-dialog v-if="paymentErrorAuditVisible" title="认款错误审核" :visible.sync="paymentErrorAuditVisible" width="800px" @close="paymentErrorClose">
      <allocation-detail :id="approvalId" ref="allocation" :thh="true" @onStatus="onStatus" />
      <span slot="footer" class="dialog-footer">

        <el-button type="default" :loading="loading" @click="cancel">驳回</el-button>
        <el-button type="primary" :loading="loading" @click="Submit">同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { selectApprovalThh, confirmApprovalThh } from '@/API';
import allocationDetail from './allocationDetail.vue';
export default {
  name: 'PaymentErrorAudit',
  components: {
    allocationDetail
  },
  data () {
    return {
      tableLoading: false,
      loading: false,
      searchForm: {
        contractNum: '',
        projectName: '',
        orderUnit: '',
        departmentName: '',
        regionName: '',
        applicationName: '',
        createBeginTime: '',
        createEndTime: ''
      },
      tableData: [],
      paymentErrorAuditVisible: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      approvalId: '',
      isShow: false,
      isBtnShow: false
    };
  },
  mounted () {
    this.initData();
  },
  methods: {
    initData () {
      if (this.searchForm.createBeginTime && this.searchForm.createEndTime && Date.parse(this.searchForm.createBeginTime) > Date.parse(this.searchForm.createEndTime)) {
        this.$message.error('申请开始时间不能大于结束时间');
        return;
      }
      let parmas = {
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.tableLoading = true;
      selectApprovalThh(parmas).then((res) => {
        let json = res.data;
        this.tableLoading = false;
        if (json.status === '200') {
          this.page.total = json.data.total;
          this.tableData = json.data.list;
        }
      }).catch((err) => {
        this.tableLoading = false;
        console.log(err);
      });
    },
    searchClick () {
      this.page.currentPage = 1;
      this.initData();
    },
    resetForm () {
      this.searchForm = {};
      this.page.currentPage = 1;
      this.page.createEndTime = '';
      this.initData();
    },
    handerCurrentChange () {
      this.initData();
    },
    toPaymentErrorAudit (row) {
      this.approvalId = row.approvalId;
      this.paymentErrorAuditVisible = true;
    },
    Submit () {
      this.loading = true;
      let reason = this.$refs.allocation.reason;
      let parmas = { approvalOpinion: reason, approvalId: this.approvalId, type: '同意' };
      confirmApprovalThh(parmas).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('审批成功');
          this.paymentErrorAuditVisible = false;
          this.initData();
        }
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      });
    },
    cancel () {
      this.loading = true;
      let reason = this.$refs.allocation.reason;
      let causeRevocation = this.$refs.allocation.causeRevocation;
      if (causeRevocation === '') {
        this.$message.error('请输入审批意见');
        this.loading = false;
        return;
      }
      let parmas = { approvalOpinion: reason, approvalId: this.approvalId, type: '驳回' };
      confirmApprovalThh(parmas).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('驳回成功');
          this.paymentErrorAuditVisible = false;
          this.initData();
        }
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      });
    },
    onStatus (val) {
      this.isShow = val;
      this.isBtnShow = true;
    },
    paymentErrorClose () {
      this.paymentErrorAuditVisible = false;
      this.isShow = false;
      this.isBtnShow = false;
      this.$refs.allocation.causeRevocation = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.date-separator {
  display: inline-block;
  width: 10px;
  text-align: center;
}
.pagination-wrap {
  text-align: right;
  margin-top: 10px;
}
</style>
